import { ProjectBase } from '../components/ProjectBase';
import { ProjectInterface } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";
import YoutubeEmbed from '../components/Youtube';

import cover from "../assets/img/puzzlecave2.png";
import img1 from "../assets/img/puzzle-frame1.webp";
import img2 from "../assets/img/puzzlecave3.png";
import img3 from "../assets/img/puzzlecave4.png";
import video from "../assets/vid/puzzle-video.mp4";


export const projectDetails: ProjectInterface = {
    url: "puzzle-cave",
    title: "Puzzle Cave",
    summary: `This is a match-3 puzzle mobile game me and a classmate created for a college assignment.`,
    description: `A match-3 puzzle mobile game where the player delve into a mysterious cave, challenged to score as many points as possible within a time limit by matching pieces on the board. Points earned translate into damage dealt to the enemy at the end of each turn, gradually whittling down their health.

        After each player turn, the enemy retaliates adding an element of unpredictability to the gameplay. Players must strategize not only to maximize their own points but also to minimize the damage they take from the enemy's strikes.

        The game also incorporates a mechanic of focused damage, where matching corresponding colored pieces grants strategic advantages like reducing enemy damage, lowering attack accuracy, or extending the player's turn time.`,
    year: "2024",
    tags: ["Match 3", "Puzzle", "RPG", "Mobile", "Unity"],
    imageSrc: cover,
    hasVideo: true,
    startVideoTime: 0,
    videoSrc: video,
    isCoverType: true,
    haveTags: true,
    projectType: ProjectType.COLLEGE,
    platforms: ["Mobile"],
    people: 2,
    roles: ["Gameplay Programmer", "3D Artist"],
    technologies: ["Unity", "C#", "Mobile"],
    collaborators: ["Lucas Coutinho", "Jonathan Passos"],
    highlightColor: "#60151F",
    descriptionTitle: "Match-3 with a Twist",
    linkData: [
        { type: 'github', url: "https://github.com/takescape/puzzle-cave" },
        { type: 'itchio', url: "https://lucasctnh.itch.io/puzzle-cave" },
        { type: 'text', url: "https://lucasctnh.itch.io/puzzle-cave" },
    ],
    relatedProjects: ["ElementalBlitz", "Asteroids", "CheckMore"],
};


export function PuzzleCave() {
    return (
        <div>
            <ProjectBase project={projectDetails}
                useCarousel={true}
                carouselData={
                    [
                        { image: img1, caption: "Main Menu" },
                        { image: cover, caption: "Gameplay" },
                        { image: img2, caption: "Gameplay" },
                        { image: img3, caption: "Gameplay" },
                    ]
                }
                leftContent={
                    <div className="a-left-no-bg">
                        <YoutubeEmbed embedId="jLGYOaFLCTU" />
                    </div>
                }
                rightContent={
                    null
                }>
            </ProjectBase>
        </div>
    );
}